import React from 'react';
import Card from '../../../../muiComponents/Card';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';

const LoadingZitoneoHotelAttributes = () => {
    return (
        <div className='your-property__container'>
            <div className='zitoneo-services-page__content'>
                <LoadingPlaceholder />
                <div className='flex-grow overflow-auto padding-right-10'>
                    <Card className='padding20'>
                        <LoadingPlaceholder
                            variant='text'
                            height={60}
                            width={'100%'}
                        />
                        <LoadingPlaceholder
                            variant='text'
                            height={60}
                            width={'100%'}
                        />
                        <LoadingPlaceholder
                            variant='text'
                            height={60}
                            width={'100%'}
                        />
                        <LoadingPlaceholder
                            variant='text'
                            height={60}
                            width={'100%'}
                        />
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default LoadingZitoneoHotelAttributes;
